import createUrlBuilder from 'utilities/url.builder.utils';
import { getRequest } from 'utilities/service.utils';
import AppService from './app.service.context';

export const fetchEmailsWithCriteria = async ({
  direction = 'inbound',
  ...params
}: any) => {
  const urlBuilder = createUrlBuilder(`/emails/${direction}`);
  return await getRequest(AppService, urlBuilder.toString(), params);
};
export const fetchEmailWithDetail = async ({ direction, emailId }: any) => {
  const urlBuilder = createUrlBuilder(`/emails/${direction}/${emailId}`);
  return await getRequest(AppService, urlBuilder.toString());
};

export const fetchAttachment = async ({ url }: { url: string }) => {
  return await fetch(url);
};
